import { ref } from "vue";

export default function usePeriodSelection() {
    const selectedPeriod = ref(null);
    const selectedPrice = ref(null);
    const selectedDuration = ref(null);
    const errorMessage = ref("");

    const onPeriodChange = (period) => {
        if (selectedPeriod.value === period.id) {
            selectedPeriod.value = null;
            selectedPrice.value = null;
            selectedDuration.value = null;
            return;
        } 
        selectedPeriod.value = period.id;
        selectedPrice.value = period.price;
        selectedDuration.value = period.durationInMonths;
        errorMessage.value = null;
    };

    return {
        selectedPeriod,
        selectedPrice,
        selectedDuration,
        errorMessage,
        onPeriodChange,
    };
}
